module.exports = now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/date-now/index.js
// module id = 308
// module chunks = 1 2